import {EmployeeData, PIMetadata} from "../../api/performanceAPI";
import {Button, HStack, Input} from "@chakra-ui/react";
import {FaFileExcel} from "react-icons/fa";
import handleExport from "./tableGenerator";


export interface PIFilters{
    name: string,
    manager: string,
    project: string,
}
export type BookingStatus = "approve" | "reject";
export type CustomerOrStrypes = "Customer Requested" | "Strypes Requested"
export type BookingDecision = {
    status?: BookingStatus |undefined
    requested?: CustomerOrStrypes | undefined
}
// Interface mapping bookingId to status
export interface BookingStatusMap {
  [bookingId: string]: BookingDecision;
}

export function HeaderFilters(props: {
                                  filters: PIFilters,
                                  handleFilterChange: (arg0: keyof PIFilters, arg1: string) => void,
                                  data: EmployeeData[],
                                  bulkUpdate: (status: BookingStatus, clearAll?: boolean, report? : boolean) => void,
    //bulk update sends request to BE
                                    bulkMark: (requested: CustomerOrStrypes) => void,
    monthCompleted: boolean,
    metadata: PIMetadata | undefined
                              },
)
{



    return (
              <HStack justifyContent="space-between" spacing={4} width="100%">
            {/* Filters */}
            <HStack spacing={4}>
              <Input
                placeholder="Filter by name"
                value={props.filters.name}
                onChange={(e) => props.handleFilterChange("name", e.target.value)}
              />
              <Input
                placeholder="Filter by manager"
                value={props.filters.manager}
                onChange={(e) => props.handleFilterChange("manager", e.target.value)}
              />
              <Input
                placeholder="Filter by project ID"
                value={props.filters.project}
                onChange={(e) => props.handleFilterChange("project", e.target.value)}
              />
            </HStack>
                  <HStack justifyContent={"start"}>
                      {!props.monthCompleted && <>
            {/* Export Button */}
                          <Button onClick={() => props.bulkMark("Customer Requested")}>Set Customer Requested</Button>
        <Button onClick={() => props.bulkMark("Strypes Requested")}>Set Strypes Requested</Button>
        <Button onClick={() => props.bulkUpdate("approve")}>Approve All</Button>
        <Button onClick={() => props.bulkUpdate("reject")}>Reject All</Button>
        <Button onClick={() => props.bulkUpdate("approve", true)}>Clear</Button> {/* Optional */}
            <Button
              onClick={()=>props.bulkUpdate("approve", true, true)}
              colorScheme="green">Finalize Review</Button>
                  </>    }
            <Button
              onClick={() =>       handleExport(props.data, props.metadata as PIMetadata)}
              colorScheme="green"
              leftIcon={<FaFileExcel />}
            >
              Export to Excel
            </Button>
                      </HStack>
          </HStack>
        )
}